import { render, staticRenderFns } from "./CollectView.vue?vue&type=template&id=6e1fd0d2&scoped=true&"
import script from "./CollectView.vue?vue&type=script&lang=js&"
export * from "./CollectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1fd0d2",
  null
  
)

export default component.exports